import type { EmailTemplate, SMSTemplate } from '@/libs/interfaces'

import { MOCK_ORG_ID, MOCK_STORE_ID_1 } from './seed'

export const mockEmailTemplates: EmailTemplate[] = [
  {
    emailTemplateID: 'email-template-1',
    storeID: MOCK_STORE_ID_1,
    orgID: MOCK_ORG_ID,
    templateTitle: 'Booking confirmation',
    templateName: 'booking-confirmation',
    templateContent: 'Hi {{customerName}}, your booking on {{bookingDate}} is confirmed.',
    createdAt: '2025-03-01T08:00:00Z',
    updatedAt: '2025-03-01T08:00:00Z',
  },
  {
    emailTemplateID: 'email-template-2',
    storeID: MOCK_STORE_ID_1,
    orgID: MOCK_ORG_ID,
    templateTitle: 'Booking reminder',
    templateName: 'booking-reminder',
    templateContent:
      'Hi {{customerName}}, this is a reminder of your booking tomorrow at {{bookingTime}}.',
    createdAt: '2025-03-02T08:00:00Z',
    updatedAt: '2025-03-02T08:00:00Z',
  },
  {
    emailTemplateID: 'email-template-3',
    storeID: MOCK_STORE_ID_1,
    orgID: MOCK_ORG_ID,
    templateTitle: 'Vehicle ready for pickup',
    templateName: 'pickup-ready',
    templateContent:
      'Hi {{customerName}}, your vehicle {{registrationNumber}} is ready for pickup.',
    createdAt: '2025-03-03T08:00:00Z',
    updatedAt: '2025-03-03T08:00:00Z',
  },
  {
    emailTemplateID: 'email-template-4',
    storeID: MOCK_STORE_ID_1,
    orgID: MOCK_ORG_ID,
    templateTitle: 'Thank you for your visit',
    templateName: 'thank-you',
    templateContent:
      'Hi {{customerName}}, thank you for visiting us. We hope to see you again soon!',
    createdAt: '2025-03-04T08:00:00Z',
    updatedAt: '2025-03-04T08:00:00Z',
  },
]

export const mockSMSTemplates: SMSTemplate[] = [
  {
    smsTemplateID: 'sms-template-1',
    storeID: MOCK_STORE_ID_1,
    orgID: MOCK_ORG_ID,
    templateTitle: 'Booking confirmation',
    templateName: 'booking-confirmation-sms',
    templateContent: 'Your booking on {{bookingDate}} is confirmed. Reply STOP to opt out.',
    createdAt: '2025-03-01T08:00:00Z',
    updatedAt: '2025-03-01T08:00:00Z',
  },
  {
    smsTemplateID: 'sms-template-2',
    storeID: MOCK_STORE_ID_1,
    orgID: MOCK_ORG_ID,
    templateTitle: 'Booking reminder',
    templateName: 'booking-reminder-sms',
    templateContent: 'Reminder: your booking is tomorrow at {{bookingTime}}.',
    createdAt: '2025-03-02T08:00:00Z',
    updatedAt: '2025-03-02T08:00:00Z',
  },
  {
    smsTemplateID: 'sms-template-3',
    storeID: MOCK_STORE_ID_1,
    orgID: MOCK_ORG_ID,
    templateTitle: 'Vehicle ready for pickup',
    templateName: 'pickup-ready-sms',
    templateContent: 'Your vehicle {{registrationNumber}} is ready for pickup.',
    createdAt: '2025-03-03T08:00:00Z',
    updatedAt: '2025-03-03T08:00:00Z',
  },
]
